angular.module('controllers').controller('restaurantTableController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$route', '$routeParams', '$location', '$timeout', '$window',
    function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $route, $routeParams, $location, $timeout, $window) {

		$rootScope.path = '/restaurant-table';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'restaurant-table';
		$scope.pathTemplate = 'restaurants/tables';
		$scope.title = 'Mese restaurant';

		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'restaurant_title';
		$scope.defaultItem = 10;
        $rootScope.typeId = 'id';
		$scope.search.order = 'asc';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
            'table_title':{'label':'Masa', 'filter':1, 'filterType':'input'},
            'restaurant_title':{'label':'Restaurant', 'filter':1, 'filterType':'input'},
			'table_seats':{'label':'Nr. locuri', 'filter':1, 'filterType':'input'},
			'table_status':{'label':'Status masa', 'filter':1, 'filterType':'select'},
			'status':{'label':'Status', 'filter':1, 'filterType':'select'}
		};

		$scope.columns.status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'true'},
			{'id':0, 'value' : 'false'}
		];
		
		$scope.columns.table_status.options = [
			{'id':'', 'value' : ''},
			{'id':1, 'value' : 'Ocupata'},
			{'id':0, 'value' : 'Libera'}
		];
		$scope.additionals['table_status'] = $scope.columns.table_status.options;
		$scope.additionals['content_type'] = 'form-urlencoded';
        $scope.additionals['columnDisplay'] = 'table_title';

        /* get dependent fields */
        $scope.getDependedFields = function () {
            Crud.getDependedFields($scope.path)
                .success(function (data) {
                    $scope.additionals['restaurants'] = data.restaurants;
                    $scope.columns.restaurant_title.options = [{id:'', value:''}];
                    angular.forEach(data.restaurants, function (item, key) {
                        $scope.columns.restaurant_title.options.push({id:item.id, value:item.restaurant_title});
                    });
                });
        }

        /* close field */
        $scope.additionals['closeField'] = function (paramName, paramId) {
            $scope.org[paramName] = '';
            $scope.org[paramId] = '';
        }

        $scope.additionals['searchTerm'];
        $scope.additionals['clearSearchTerm'] = function() {
            $scope.additionals['searchTerm'] = '';
        };
        $scope.additionals['onSearchChange'] = function(ev) {
            ev.stopPropagation();
        };

        $scope.additionals['functionResult'] = function(ev, data) {
            if (!angular.isUndefined($scope.modelData.table_title)) {
                $scope.modelData.table_title = $scope.additionals['formatTextResult']($scope.modelData.table_title);
            }
            if (!angular.isUndefined($scope.modelsData)) {
                angular.forEach($scope.modelsData, function (item, key) {
                    if (!angular.isUndefined($scope.modelsData[key].table_title)) {
                        $scope.modelsData[key].table_title = $scope.additionals['formatTextResult']($scope.modelsData[key].table_title);
                    }
                });
            }
        }

	}]
);
